<template>
  <footer v-if="showFooter" class="app-footer">
    <div class="footer-container">
      <!-- Left section: Empty for balance -->
      <div class="footer-section"></div>

      <!-- Center section: Footer text and logo -->
      <div class="footer-section footer-brand">
        <span v-if="footerText" class="footer_text">{{ footerText }}</span>
        <img 
          v-if="footerLogo"
          :src="footerLogo" 
          alt="Footer Logo" 
          class="footer-logo"
        />
      </div>

      <!-- Right section: Empty for balance -->
      <div class="footer-section"></div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    branding() {
      return this.$store?.getters?.get_branding || {};
    },
    footerLogo() {
      const url = this.branding.footer_logo_url;
      return (url && url.trim()) ? url : null;
    },
    footerText() {
      const text = this.branding.app_footer_text;
      return (text && text.trim()) ? text : null;
    },
    showFooter() {
      return !!(this.footerLogo || this.footerText);
    },
  },
};
</script>

<style scoped>
.app-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
  padding: 12px 24px;
  margin-top: auto;
  width: 100%;
  font-size: 0.8rem;
}

.footer-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1400px;
  margin: 0 auto;
}

.footer-section {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.footer-brand {
  justify-content: center;
}

.footer_text {
  color: #6c757d;
  font-size: 0.75rem;
}

.footer-logo {
  height: 20px;
  width: auto;
  object-fit: contain;
}

.footer-info {
  justify-content: flex-end;
}

.copyright {
  color: #6c757d;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .footer-container {
    flex-direction: column;
    gap: 8px;
  }

  .footer-section {
    justify-content: center;
  }
}
</style>
